import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import DipenDewan from "../../../images/Photos/Dipen Dewan.jpg";
import GayetreeChakma from "../../../images/Photos/Gayetree Chakma.jpeg";
import NirmalKantiChakma from "../../../images/Photos/Nirmal Kanti Chakma.jpeg";
import SumantiChakma from "../../../images/Photos/Sumanti Chakma.jpg";
import RupanKumarChakma from "../../../images/Photos/Rupan Kumar Chakma.jpg";
import "../../../style/about/advisoryBoard.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon
} from "react-share";

const AdvisoryCouncil = () => {
  useEffect(() => {
    document.title = `Development Concern | Advisory Council`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/advisory-council";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="advisory_board_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>Advisory Council</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Advisory Council</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Advisory Council</h1>
          <div className="title_header">
            <p>
              Development Concern has Advisory council consisting of 5 members where 2 women member is compulsory. This AC provides necessary advices/counseling to the executive council in regards of management, project implementation and fund-raising etc.
            </p>
          </div>

          <div className="content_wrapper">
            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={DipenDewan} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Dipen Dewan</h4>
                  <p>Chief Advisor</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={GayetreeChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Gayetree Chakma</h4>
                  <p>Advisor</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={NirmalKantiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Nirmal Kanti Chakma</h4>
                  <p>Advisor</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={SumantiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Sumanti Chakma</h4>
                  <p>Advisor</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={RupanKumarChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Rupan Kumar Chakma</h4>
                  <p>Advisor</p>
                </div>
              </div>
            </Zoom>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdvisoryCouncil;
